// Bottom chrome strip — legend + scale.

export function ScaleBar() {
  return (
    <div className="border-rule flex items-center justify-between gap-6 border-t px-4 py-1.5">
      <div className="n5-marginalia flex items-center gap-3">
        <span>Legend</span>
        <span className="flex items-center gap-1.5">
          <Swatch fill="empty" />
          fresh
        </span>
        <span className="flex items-center gap-1.5">
          <Swatch fill="partial" />
          known once
        </span>
        <span className="flex items-center gap-1.5">
          <Swatch fill="full" />
          graduated
        </span>
      </div>
      <div className="n5-marginalia hidden items-center gap-3 sm:flex">
        <span>Scale</span>
        <span className="flex items-center gap-1">
          {Array.from({ length: 5 }, (_, i) => (
            <span
              key={i}
              className="inline-block"
              style={{
                width: 10,
                height: 8,
                border: "1px solid var(--rule-strong)",
                background: "var(--paper)",
              }}
            />
          ))}
        </span>
        <span>= 1% corpus frequency</span>
      </div>
    </div>
  );
}

function Swatch({ fill }: { fill: "empty" | "partial" | "full" }) {
  return (
    <span
      className="inline-block"
      style={{
        width: 10,
        height: 10,
        border: "1px solid var(--rule-strong)",
        background:
          fill === "empty"
            ? "var(--paper)"
            : fill === "partial"
              ? "color-mix(in oklch, var(--claimed) 50%, var(--paper))"
              : "var(--claimed)",
      }}
    />
  );
}
